import Paper from "@material-ui/core/Paper";
import BorderLessInput, { PlaceholderChildContainer, PlaceholderLabelSpacing, PlaceholderParentContainer } from "../Custom/BorderLessInput";
import React, { FC, useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useFormContext } from "react-hook-form";
import "./style.scss";

interface Props {
  selectedData: any;
  selectedType: string;
  storeHistory: (
    field: string,
    value: any,
    type: string,
    optional?: any
  ) => void;
  setRedoState: (redoState: any) => void;
}

const CustomPaper = (props: any) => {
  return (
    <Paper
      style={{
        color: "#FFFF",
        background: "transparent",
        marginButtom: "10px",
        borderBottom: "2px dashed #FFFF",
      }}
      {...props}
    />
  );
};

const CurrencyInput: FC<Props> = () => {
  const { watch, setValue } = useFormContext();
  const [currencyOptions, setCurrencyOptions] = useState<[any]>([
    { label: "EUR", value: "EUR" },
  ]);

  useEffect(() => {
    setCurrencyOptions([{ label: "EUR", value: "EUR" }]);
  }, []);

  return (
    <div className="input-container">
      {watch("options")?.map((field: any, index: number) => {
        return (
          <React.Fragment>
            <PlaceholderLabelSpacing>
              <BorderLessInput
                color="white"
                placeHolder="Label (Optional)"
                value={watch(`options[${index}].label`) || ""}
                setValue={(value: string) => {
                  setValue(`options[${index}].label`, value);
                }}
              />
            </PlaceholderLabelSpacing>
            <div className="input-currency">
              <PlaceholderParentContainer>
                <TextField
                  disabled={true}
                  key={field?.id}
                  variant="standard"
                  className="cost-amount"
                  InputLabelProps={{ shrink: true }}
                />
                <PlaceholderChildContainer>
                  <BorderLessInput
                    color=""
                    fullWidth
                    placeHolder="Placeholder (Optional)"
                    value={watch(`options[${index}].placeholder`) || ""}
                    setValue={(value: string) => {
                      setValue(`options[${index}].placeholder`, value);
                    }}
                  />
                </PlaceholderChildContainer>
              </PlaceholderParentContainer>
              <Autocomplete
                className="currency-dropdown"
                options={currencyOptions}
                value="EUR"
                disabled
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Currency"
                    variant="standard"
                  />
                )}
                PaperComponent={CustomPaper}
              />
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default CurrencyInput;
